import { createVNode, render } from 'vue';
import ConfirmDialog from './index.vue';

function showConfirm(options = {}) {
  // 确保 options 是对象
  if (typeof options === 'string') {
    options = { content: options };
  }

  // 默认配置
  const defaultOptions = {
    title: '',
    content: '',
    cancelText: 'Cancel',
    confirmText: 'Confirm',
    isCancel: true,
    isConfirm: true,
    close: () => { },
    cancel: () => { },
    confirm: () => { }
  };

  // 合并配置
  const mergedOptions = { ...defaultOptions, ...options };

  // 创建一个容器元素
  const container = document.createElement('div');
  document.body.appendChild(container);

  // 创建虚拟节点
  const vnode = createVNode(ConfirmDialog, {
    ...mergedOptions,
    visible: true,
    // 重写关闭相关的回调函数
    close: () => {
      mergedOptions.close();
      unmount();
    },
    cancel: () => {
      mergedOptions.cancel();
      unmount();
    },
    confirm: () => {
      mergedOptions.confirm();
      unmount();
    }
  });

  // 卸载函数
  function unmount() {
    render(null, container);
    if (container.parentNode) {
      container.parentNode.removeChild(container);
    }
  }

  // 渲染到DOM
  render(vnode, container);

  // 返回关闭方法
  return {
    close: unmount
  };
}

// Export as a Vue plugin with default export
export default {
  install(app) {
    // Add global property
    app.config.globalProperties.$confirm = showConfirm;
  }
};

// Also export the function for direct use
export { showConfirm };